import { useState, useEffect, SyntheticEvent } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import Icon from '../../../../components/icon'
import apiUrl from '../../../../configs/constant'
import { NumericFormat } from 'react-number-format'

import {
    Box,
    Grid,
    Typography,
    Divider,
    Fab,
    Button,
    FormControl,
    TextField,
    FormHelperText,
    Autocomplete
} from '@mui/material'

interface FormInputs {
    mmbarang_id: any
    mmjenis_barang_id: any
    tgl: any
    harga: any
    harga_min: any
    keterangan: any
}

export default function AddHargaBarang() {
    const navigate = useNavigate()
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const [valBarang, setValBarang] = useState<any>(null)
    const [listBarang, setListBarang] = useState<any[]>([])
    const [valJenisBarang, setValJenisBarang] = useState<any>(null)
    const [listJenisBarang, setListJenisBarang] = useState<any[]>([])
    useEffect(() => {
        axios
            .get(apiUrl.apiUrl + '/mm/jenis-barang/list-combo', {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.success) setListJenisBarang(res.data.data)
            })
    }, [token])

    const getBarang = (mmjenis_barang_id: any) => {
        if (mmjenis_barang_id) {
            axios
                .get(apiUrl.apiUrl + '/mm/barang/list-combo-harga-barang', {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { mmjenis_barang_id }
                })
                .then(res => {
                    if (res.data.success) {
                        setListBarang(res.data.data)
                        setValBarang(null) // Reset selected barang when jenis changes
                        setValue('mmbarang_id', null)
                    }
                })
                .catch(error => {
                    console.error('Error fetching barang:', error)
                })
        } else {
            setListBarang([])
            setValBarang(null)
            setValue('mmbarang_id', null)
        }
    }

    const defaultValues: Partial<FormInputs> = {
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
    }

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: FormInputs) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })
                axios
                    .post(apiUrl.apiUrl + '/mm/harga-barang/add', {
                        ...data,
                        harga: Number(data.harga)
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/mm/harga-barang')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const handleChangeAutocompleteBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_id', newValue ? newValue.id : null)
        setValBarang(newValue)
    }
    const handleChangeAutocompleteJenisBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmjenis_barang_id', newValue ? newValue.id : null)
        setValJenisBarang(newValue)
        getBarang(newValue ? newValue.id : null)
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ padding: 20 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center', marginBottom: 2 }}>
                        Form Update Harga Barang
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmjenis_barang_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valJenisBarang}
                                                options={listJenisBarang}
                                                id='jenisBarang'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                                onChange={handleChangeAutocompleteJenisBarang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                        label='Jenis Barang'
                                                        error={Boolean(errors.mmjenis_barang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmjenis_barang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valBarang}
                                                options={listBarang}
                                                id='barang'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                                onChange={handleChangeAutocompleteBarang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Barang'
                                                        error={Boolean(errors.mmbarang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='harga'
                                        control={control}
                                        rules={{ required: true, min: 0.01 }}
                                        render={({ field }) => (
                                            <NumericFormat
                                                customInput={TextField}
                                                label='Harga'
                                                thousandSeparator
                                                decimalScale={2}
                                                fixedDecimalScale
                                                allowNegative={false}
                                                value={field.value}
                                                onValueChange={values => field.onChange(values.floatValue ?? 0)}
                                                error={Boolean(errors.harga)}
                                                InputLabelProps={{ shrink: true }}
                                                helperText={errors.harga && 'Form ini tidak boleh kosong.'}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='harga_min'
                                        control={control}
                                        rules={{ required: true, min: 0.01 }}
                                        render={({ field }) => (
                                            <NumericFormat
                                                customInput={TextField}
                                                label='Harga Minimum'
                                                thousandSeparator
                                                decimalScale={2}
                                                fixedDecimalScale
                                                allowNegative={false}
                                                value={field.value}
                                                onValueChange={values => field.onChange(values.floatValue ?? 0)}
                                                error={Boolean(errors.harga_min)}
                                                InputLabelProps={{ shrink: true }}
                                                helperText={errors.harga_min && 'Form ini tidak boleh kosong.'}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                             <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                label='Keterangan'
                                                multiline
                                                rows={3}
                                                {...field}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                    <Button variant='contained' type='submit'>
                                        SIMPAN
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}